import React from 'react';
import { arrayOf, any } from 'prop-types';
import InputField from '#component/form/input';
import { StyledAutocomplete } from './styles';

/**
 * Renders MUI Autocomplete adjusted for form usage.
 */

const AutocompleteField = props => {
  const {
    options,
    inputProps = {},
    freeSolo = false,
    serviceMethods,
    meta = {},
    ...rest
  } = props;

  const input = props.input || {
    onChange: props.onChange,
    onBlur: props.onBlur,
    value: props.value,
    name: props.name
  };

  const handleChange = (event, value) => {
    input.onChange?.(value);
  };
  const handleBlur = event => {
    input.onChange?.(event.target.value || null);
    serviceMethods?.dispatchClearOptions?.();
  };

  return (
    <StyledAutocomplete
      freeSolo={freeSolo}
      options={options}
      value={input.value || null}
      onChange={handleChange}
      renderInput={({ InputProps, ...params }) => <InputField
        {...params}
        meta={meta}
        onBlur={freeSolo ? handleBlur : () => {}}
        {...inputProps}
        InputProps={{ ...(InputProps ?? {}), ...(inputProps?.InputProps ?? {}) }}
        type="search"
      />}
      {...rest}
    />
  );
};

AutocompleteField.propTypes = {
  options: arrayOf(any).isRequired
};

export default AutocompleteField;
